import React from 'react';
export function HeroSection() {
  return <section className="relative bg-brand-dark text-white py-20 lg:py-32 overflow-hidden" data-id="element-439">
      <div className="absolute inset-0 bg-black/75 z-10" data-id="element-440"></div>
      <div className="absolute inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/mnYnLdKB4CX3ZrYpuepiJd/hero3.png)'
    }} data-id="element-441"></div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-442">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight leading-tight" data-id="element-443">
          Stop Hauling Chemicals Into Crawlspaces.
        </h1>
        <p className="text-2xl md:text-3xl text-brand-yellow font-bold mb-6 max-w-4xl mx-auto leading-relaxed" data-id="element-444">
          ForceX is a corded, siphon-fed sprayer built for contractors—no
          pumping, no refilling, no batteries dying mid-job.
        </p>
        <p className="text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-445">
          Spray faster, safer, and more consistently in attics, crawlspaces,
          basements, and tight spaces.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-446">
          <a href="#kits" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-447">
            View Kits
          </a>
          <a href="tel:+18108185941" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide border-2 border-white text-white hover:bg-white hover:text-brand-dark focus:ring-brand-dark h-14 px-8 text-lg" data-id="element-448">
            Call Now
          </a>
        </div>
      </div>
    </section>;
}